import { Bounce, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * @param id dismiss just that toast. Without one, every toast goes, which is
 *  what this did before ids were passed
 */
export function dismiss(id) {
    toast.dismiss(id);
}

export function error(message) {
    return toast.error(message, {
        position: 'top-center',
        autoClose: message?.length > 100 ? 15000 : 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
        transition: Bounce,
    });
}

/**
 * For telling someone what to do next rather than what happened. Pass
 *  `autoClose: false` for a message that should stay until the thing it is
 *  describing is over, and dismiss it by the id this returns.
 */
export function info(message, options = {}) {
    return toast.info(message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
        transition: Bounce,
        ...options,
    });
}

export function success(message) {
    return toast.success(message, {
        position: 'top-center',
        autoClose: message?.length > 100 ? 15000 : 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
        transition: Bounce,
    });
}
